import { doFetch, doPutFetch, doPostFetch } from "./apiFetchHelper";

const API_URL = `/api/member`;

export function registerNewMember(memberData) {
  return doPostFetch(API_URL, memberData);
}

export function completeAccountSetup(data) {
  return doPostFetch(`${API_URL}/complete-account-setup`, data);
}

export function fetchMemberAccountInfo() {
  return doFetch(API_URL);
}

export function updateMemberAccountInfo(data) {
  return doPutFetch(API_URL, data);
}

export function completeMemberProfile(memberData) {
  return doPutFetch(`${API_URL}/complete-member-profile`, memberData);
}

export function checkEmailAvailability(email) {
  return doPostFetch(`${API_URL}/is-email-available`, { email });
}

export function checkRegistrationCode(code) {
  return doPostFetch(`${API_URL}/check-registration-code`, { code });
}

export function checkMemberId(memberId) {
  return doPostFetch(`${API_URL}/check-member-id`, { memberId });
}

export function fetchMemberDefaultLocation() {
  return doFetch(`${API_URL}/get-default-location`);
}

export default {
  completeAccountSetup,
  registerNewMember,
  fetchMemberAccountInfo,
  updateMemberAccountInfo,
  completeMemberProfile,
  checkEmailAvailability,
  checkRegistrationCode,
  checkMemberId,
  fetchMemberDefaultLocation,
};
